/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";

export default function Model(props) {
	const { nodes, materials } = useGLTF("models/factory2.glb");
	return (
		<group {...props} dispose={null}>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube073.geometry}
				material={materials["Material.007"]}
				position={[0.012, 0, 0.239]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.pPlane511.geometry}
				material={materials["Material.007"]}
				position={[0.27, -0.046, 0.217]}
				rotation={[Math.PI / 2, 0, -Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.pCube161.geometry}
				material={materials["Material.007"]}
				position={[0.271, 0.955, 0.246]}
				rotation={[Math.PI / 2, 0, -Math.PI / 2]}
				scale={[0.018, 0.007, 0.007]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface576.geometry}
				material={materials["Material.007"]}
				position={[0.271, 0.955, 0.246]}
				rotation={[Math.PI / 2, 0, -Math.PI / 2]}
				scale={[0.018, 0.007, 0.007]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface582.geometry}
				material={materials["Material.007"]}
				position={[0.271, 0.955, 0.246]}
				rotation={[Math.PI / 2, 0, -Math.PI / 2]}
				scale={[0.018, 0.007, 0.007]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.pPlane487.geometry}
				material={materials["Material.007"]}
				position={[0.27, -0.046, 0.217]}
				rotation={[Math.PI / 2, 0, -Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.pPlane496.geometry}
				material={materials["Material.007"]}
				position={[0.41, -0.046, 0.217]}
				rotation={[Math.PI / 2, 0, -Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.pPlane493.geometry}
				material={materials["Material.007"]}
				position={[0.27, -0.046, 0.228]}
				rotation={[Math.PI / 2, 0, -Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.pPlane492.geometry}
				material={materials["Material.007"]}
				position={[0.27, -0.046, 0.155]}
				rotation={[Math.PI / 2, 0, -Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.pPlane491.geometry}
				material={materials["Material.007"]}
				position={[0.27, -0.046, 0.217]}
				rotation={[Math.PI / 2, 0, -Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface565.geometry}
				material={materials["Material.007"]}
				position={[0.27, -0.046, 0.217]}
				rotation={[Math.PI / 2, 0, -Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface554.geometry}
				material={materials["Material.007"]}
				position={[0.27, -0.046, 0.217]}
				rotation={[Math.PI / 2, 0, -Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface552.geometry}
				material={materials["Material.007"]}
				position={[0.27, -0.046, 0.217]}
				rotation={[Math.PI / 2, 0, -Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface549.geometry}
				material={materials["Material.007"]}
				position={[0.27, -0.046, 0.217]}
				rotation={[Math.PI / 2, 0, -Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface548.geometry}
				material={materials["Material.007"]}
				position={[0.27, -0.046, 0.217]}
				rotation={[Math.PI / 2, 0, -Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface546.geometry}
				material={materials["Material.007"]}
				position={[0.27, -0.046, 0.217]}
				rotation={[Math.PI / 2, 0, -Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface654.geometry}
				material={materials["Material.007"]}
				position={[0.27, -0.046, 0.217]}
				rotation={[Math.PI / 2, 0, -Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface653.geometry}
				material={materials["Material.007"]}
				position={[0.27, -0.046, 0.217]}
				rotation={[Math.PI / 2, 0, -Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface675.geometry}
				material={materials["Material.007"]}
				position={[0.27, -0.046, 0.217]}
				rotation={[Math.PI / 2, 0, -Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface801.geometry}
				material={materials["Material.007"]}
				position={[0.27, -0.046, 0.217]}
				rotation={[Math.PI / 2, 0, -Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface802.geometry}
				material={materials["Material.007"]}
				position={[0.272, 0.955, 0.246]}
				rotation={[Math.PI / 2, 0, -Math.PI / 2]}
				scale={[0.018, 0.007, 0.007]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface638.geometry}
				material={materials["Material.007"]}
				position={[0.27, -0.046, 0.217]}
				rotation={[Math.PI / 2, 0, -Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface636.geometry}
				material={materials["Material.007"]}
				position={[0.27, -0.046, 0.217]}
				rotation={[Math.PI / 2, 0, -Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface635.geometry}
				material={materials["Material.007"]}
				position={[0.27, -0.046, 0.217]}
				rotation={[Math.PI / 2, 0, -Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface537.geometry}
				material={materials["Material.007"]}
				position={[0.27, -0.046, 0.217]}
				rotation={[Math.PI / 2, 0, -Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface532.geometry}
				material={materials["Material.007"]}
				position={[0.27, 0.011, 0.217]}
				rotation={[Math.PI / 2, 0, -Math.PI / 2]}
				scale={0.01}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface526.geometry}
				material={materials["Material.007"]}
				position={[0.27, -0.046, 0.217]}
				rotation={[Math.PI / 2, 0, -Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface659.geometry}
				material={materials["Material.007"]}
				position={[0.27, -0.046, 0.217]}
				rotation={[Math.PI / 2, 0, -Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface658.geometry}
				material={materials["Material.007"]}
				position={[0.27, -0.046, 0.217]}
				rotation={[Math.PI / 2, 0, -Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface657.geometry}
				material={materials["Material.007"]}
				position={[0.27, -0.046, 0.217]}
				rotation={[Math.PI / 2, 0, -Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface656.geometry}
				material={materials["Material.007"]}
				position={[0.27, -0.046, 0.217]}
				rotation={[Math.PI / 2, 0, -Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface798.geometry}
				material={materials["Material.007"]}
				position={[0.271, 0.955, 0.246]}
				rotation={[Math.PI / 2, 0, -Math.PI / 2]}
				scale={[0.018, 0.007, 0.007]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface806.geometry}
				material={materials["Material.007"]}
				position={[0.271, 0.955, 0.245]}
				rotation={[Math.PI / 2, 0, -Math.PI / 2]}
				scale={[0.018, 0.007, 0.007]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface503.geometry}
				material={materials["Material.007"]}
				position={[0.27, -0.046, 0.217]}
				rotation={[Math.PI / 2, 0, -Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface502.geometry}
				material={materials["Material.007"]}
				position={[0.27, -0.046, 0.217]}
				rotation={[Math.PI / 2, 0, -Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface507.geometry}
				material={materials["Material.007"]}
				position={[0.27, -0.046, 0.217]}
				rotation={[Math.PI / 2, 0, -Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface506.geometry}
				material={materials["Material.007"]}
				position={[0.27, -0.046, 0.217]}
				rotation={[Math.PI / 2, 0, -Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface505.geometry}
				material={materials["Material.007"]}
				position={[0.27, -0.046, 0.217]}
				rotation={[Math.PI / 2, 0, -Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface706.geometry}
				material={materials["Material.007"]}
				position={[0.27, -0.046, 0.217]}
				rotation={[Math.PI / 2, 0, -Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface707.geometry}
				material={materials["Material.007"]}
				position={[0.27, -0.046, 0.217]}
				rotation={[Math.PI / 2, 0, -Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface338.geometry}
				material={materials["Material.007"]}
				position={[0.27, -0.046, 0.217]}
				rotation={[Math.PI / 2, 0, -Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface339.geometry}
				material={materials["Material.007"]}
				position={[0.27, -0.046, 0.217]}
				rotation={[Math.PI / 2, 0, -Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.pPlane497001.geometry}
				material={materials["Material.007"]}
				position={[0.114, -0.046, 0.181]}
				rotation={[Math.PI / 2, 0, Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface504001.geometry}
				material={materials["Material.007"]}
				position={[0.218, -0.046, 0.181]}
				rotation={[Math.PI / 2, 0, Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface503001.geometry}
				material={materials["Material.007"]}
				position={[0.218, -0.046, 0.181]}
				rotation={[Math.PI / 2, 0, Math.PI / 2]}
				scale={0.011}
			/>
			<group position={[-1.742, 0.029, 0.235]} scale={0.608}>
				<mesh
					castShadow
					receiveShadow
					geometry={nodes.Plane010.geometry}
					material={materials["Material.008"]}
				/>
				<mesh
					castShadow
					receiveShadow
					geometry={nodes.Plane010_1.geometry}
					material={materials["Material.012"]}
				/>
			</group>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube008.geometry}
				material={materials["Material.007"]}
				position={[-1.05, 0.493, -1.585]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube014.geometry}
				material={materials["Material.007"]}
				position={[-1.752, 0.415, -1.576]}
				scale={[0.159, 0.03, 0.622]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube047.geometry}
				material={materials["Material.007"]}
				position={[1.003, 0.453, -1.593]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder028.geometry}
				material={materials["Material.007"]}
				position={[0.2, 0.634, -0.809]}
				scale={[0.102, 0.624, 0.102]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder029.geometry}
				material={materials["Material.007"]}
				position={[0.795, 0.634, -0.809]}
				scale={[0.102, 0.624, 0.102]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube050.geometry}
				material={materials["Material.007"]}
				position={[1.696, 0.355, -0.803]}
				scale={[0.008, 0.349, 0.349]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube074.geometry}
				material={materials["Material.007"]}
				position={[1.93, 0.355, -0.803]}
				scale={[0.008, 0.349, 0.349]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube075.geometry}
				material={materials["Material.007"]}
				position={[2.18, 0.355, -0.803]}
				scale={[0.008, 0.349, 0.349]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube078.geometry}
				material={materials["Material.007"]}
				position={[1.003, 0.453, 2.146]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder030.geometry}
				material={materials["Material.007"]}
				position={[0.2, 0.634, 1.362]}
				rotation={[0, 0, -Math.PI]}
				scale={[-0.102, -0.624, -0.102]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder031.geometry}
				material={materials["Material.007"]}
				position={[0.795, 0.634, 1.362]}
				rotation={[0, 0, -Math.PI]}
				scale={[-0.102, -0.624, -0.102]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube079.geometry}
				material={materials["Material.007"]}
				position={[1.696, 0.355, 1.355]}
				rotation={[0, 0, -Math.PI]}
				scale={[-0.008, -0.349, -0.349]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube080.geometry}
				material={materials["Material.007"]}
				position={[1.93, 0.355, 1.355]}
				rotation={[0, 0, -Math.PI]}
				scale={[-0.008, -0.349, -0.349]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube081.geometry}
				material={materials["Material.007"]}
				position={[2.18, 0.355, 1.355]}
				rotation={[0, 0, -Math.PI]}
				scale={[-0.008, -0.349, -0.349]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder032.geometry}
				material={materials["Material.007"]}
				position={[1.903, 0.827, 0.268]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube076.geometry}
				material={materials["Material.007"]}
				position={[1.747, 0.205, -0.065]}
				scale={[0.018, 0.194, 0.018]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube077.geometry}
				material={materials["Material.007"]}
				position={[1.904, 0.205, -0.117]}
				scale={[0.018, 0.194, 0.018]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube082.geometry}
				material={materials["Material.007"]}
				position={[2.05, 0.205, -0.08]}
				scale={[0.018, 0.194, 0.018]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube083.geometry}
				material={materials["Material.007"]}
				position={[2.173, 0.205, 0.002]}
				scale={[0.018, 0.194, 0.018]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube084.geometry}
				material={materials["Material.007"]}
				position={[2.237, 0.205, 0.118]}
				scale={[0.018, 0.194, 0.018]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube085.geometry}
				material={materials["Material.007"]}
				position={[2.278, 0.205, 0.271]}
				scale={[0.018, 0.194, 0.018]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube086.geometry}
				material={materials["Material.007"]}
				position={[2.263, 0.205, 0.413]}
				scale={[0.018, 0.194, 0.018]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube087.geometry}
				material={materials["Material.007"]}
				position={[2.177, 0.205, 0.537]}
				scale={[0.018, 0.194, 0.018]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube088.geometry}
				material={materials["Material.007"]}
				position={[2.031, 0.205, 0.604]}
				scale={[0.018, 0.194, 0.018]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube089.geometry}
				material={materials["Material.007"]}
				position={[1.893, 0.205, 0.615]}
				scale={[0.018, 0.194, 0.018]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube090.geometry}
				material={materials["Material.007"]}
				position={[1.77, 0.205, 0.604]}
				scale={[0.018, 0.194, 0.018]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube091.geometry}
				material={materials["Material.007"]}
				position={[1.639, 0.205, 0.526]}
				scale={[0.018, 0.194, 0.018]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube092.geometry}
				material={materials["Material.007"]}
				position={[1.579, 0.205, 0.413]}
				scale={[0.018, 0.194, 0.018]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube093.geometry}
				material={materials["Material.007"]}
				position={[1.523, 0.205, 0.268]}
				scale={[0.018, 0.194, 0.018]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube094.geometry}
				material={materials["Material.007"]}
				position={[1.564, 0.205, 0.107]}
				scale={[0.018, 0.194, 0.018]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube095.geometry}
				material={materials["Material.007"]}
				position={[1.643, 0.205, -0.009]}
				scale={[0.018, 0.194, 0.018]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube096.geometry}
				material={materials["Material.007"]}
				position={[1.945, 1.058, 1.131]}
				scale={[1, 0.871, 1]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube097.geometry}
				material={materials["Material.007"]}
				position={[1.945, 1.058, -0.485]}
				scale={[1, 0.871, 1]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube098.geometry}
				material={materials["Material.007"]}
				position={[1.942, 1.418, 0.313]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube100.geometry}
				material={materials["Material.007"]}
				position={[-1.227, 0.071, 1.739]}
				rotation={[-Math.PI, 0, -Math.PI]}
				scale={0.693}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cube101.geometry}
				material={materials["Material.007"]}
				position={[-0.848, 0.294, 2.135]}
				scale={[0.344, 0.221, 0.705]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder033.geometry}
				material={materials["Material.007"]}
				position={[-1.737, 0.175, 1.881]}
				scale={[0.234, 0.167, 0.234]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder034.geometry}
				material={materials["Material.007"]}
				position={[-1.864, 0.175, 1.881]}
				rotation={[Math.PI, 0, Math.PI]}
				scale={[0.234, 0.167, 0.234]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Plane011.geometry}
				material={materials["Material.007"]}
				position={[-2.092, 0.091, 2.19]}
				scale={0.69}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder035.geometry}
				material={materials["Material.007"]}
				position={[-1.737, 0.175, 2.485]}
				scale={[0.234, 0.167, 0.234]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder036.geometry}
				material={materials["Material.007"]}
				position={[-1.864, 0.175, 2.485]}
				rotation={[Math.PI, 0, Math.PI]}
				scale={[0.234, 0.167, 0.234]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder037.geometry}
				material={materials["Material.007"]}
				position={[-2.367, 0.175, 1.881]}
				scale={[0.234, 0.167, 0.234]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder038.geometry}
				material={materials["Material.007"]}
				position={[-2.493, 0.175, 1.881]}
				rotation={[Math.PI, 0, Math.PI]}
				scale={[0.234, 0.167, 0.234]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder039.geometry}
				material={materials["Material.007"]}
				position={[-2.367, 0.175, 2.485]}
				scale={[0.234, 0.167, 0.234]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder040.geometry}
				material={materials["Material.007"]}
				position={[-2.493, 0.175, 2.485]}
				rotation={[Math.PI, 0, Math.PI]}
				scale={[0.234, 0.167, 0.234]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder041.geometry}
				material={materials["Material.007"]}
				position={[-1.851, 0.216, -2.133]}
				scale={[0.047, 0.208, 0.047]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder042.geometry}
				material={materials["Material.007"]}
				position={[-1.851, 0.216, -1.675]}
				scale={[0.047, 0.208, 0.047]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder043.geometry}
				material={materials["Material.007"]}
				position={[-1.851, 0.216, -1.477]}
				scale={[0.047, 0.208, 0.047]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Cylinder044.geometry}
				material={materials["Material.007"]}
				position={[-1.851, 0.216, -1.019]}
				scale={[0.047, 0.208, 0.047]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface576001.geometry}
				material={materials["Material.007"]}
				position={[0.001, 0.955, 0.246]}
				rotation={[Math.PI / 2, 0, -Math.PI / 2]}
				scale={[0.018, 0.007, 0.007]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface582001.geometry}
				material={materials["Material.007"]}
				position={[0.001, 0.955, 0.246]}
				rotation={[Math.PI / 2, 0, -Math.PI / 2]}
				scale={[0.018, 0.007, 0.007]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface654001.geometry}
				material={materials["Material.007"]}
				position={[0.226, -0.046, 0.217]}
				rotation={[Math.PI / 2, 0, Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface654002.geometry}
				material={materials["Material.007"]}
				position={[0.226, -0.017, 0.232]}
				rotation={[Math.PI / 2, 0, 0]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface658001.geometry}
				material={materials["Material.007"]}
				position={[-0.624, -0.046, 0.217]}
				rotation={[Math.PI / 2, 0, -Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface657001.geometry}
				material={materials["Material.007"]}
				position={[-0.624, -0.046, 0.217]}
				rotation={[Math.PI / 2, 0, -Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface659001.geometry}
				material={materials["Material.007"]}
				position={[-0.17, -0.046, 0.217]}
				rotation={[Math.PI / 2, 0, -Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface656001.geometry}
				material={materials["Material.007"]}
				position={[-0.17, -0.046, 0.217]}
				rotation={[Math.PI / 2, 0, -Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface806001.geometry}
				material={materials["Material.007"]}
				position={[0.246, 0.955, 0.245]}
				rotation={[Math.PI / 2, 0, Math.PI / 2]}
				scale={[0.018, 0.007, 0.007]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface338001.geometry}
				material={materials["Material.007"]}
				position={[0.244, -0.046, 0.217]}
				rotation={[Math.PI / 2, 0, Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface339001.geometry}
				material={materials["Material.007"]}
				position={[0.244, -0.046, 0.217]}
				rotation={[Math.PI / 2, 0, Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface565001.geometry}
				material={materials["Material.007"]}
				position={[0.279, -0.024, 0.217]}
				rotation={[Math.PI / 2, 0, Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface554001.geometry}
				material={materials["Material.007"]}
				position={[0.279, -0.024, 0.217]}
				rotation={[Math.PI / 2, 0, Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface552001.geometry}
				material={materials["Material.007"]}
				position={[0.279, -0.024, 0.217]}
				rotation={[Math.PI / 2, 0, Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface549001.geometry}
				material={materials["Material.007"]}
				position={[0.279, -0.024, 0.217]}
				rotation={[Math.PI / 2, 0, Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface548001.geometry}
				material={materials["Material.007"]}
				position={[0.279, -0.024, 0.217]}
				rotation={[Math.PI / 2, 0, Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface546001.geometry}
				material={materials["Material.007"]}
				position={[0.279, -0.024, 0.217]}
				rotation={[Math.PI / 2, 0, Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface675001.geometry}
				material={materials["Material.007"]}
				position={[0.279, -0.024, 0.217]}
				rotation={[Math.PI / 2, 0, Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface801001.geometry}
				material={materials["Material.007"]}
				position={[0.279, -0.024, 0.217]}
				rotation={[Math.PI / 2, 0, Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface638001.geometry}
				material={materials["Material.007"]}
				position={[0.279, -0.024, 0.217]}
				rotation={[Math.PI / 2, 0, Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface636001.geometry}
				material={materials["Material.007"]}
				position={[0.279, -0.024, 0.217]}
				rotation={[Math.PI / 2, 0, Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface635001.geometry}
				material={materials["Material.007"]}
				position={[0.279, -0.024, 0.217]}
				rotation={[Math.PI / 2, 0, Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface526001.geometry}
				material={materials["Material.007"]}
				position={[0.279, -0.024, 0.217]}
				rotation={[Math.PI / 2, 0, Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface706001.geometry}
				material={materials["Material.007"]}
				position={[0.279, -0.024, 0.217]}
				rotation={[Math.PI / 2, 0, Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface707001.geometry}
				material={materials["Material.007"]}
				position={[0.279, -0.024, 0.217]}
				rotation={[Math.PI / 2, 0, Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface502001.geometry}
				material={materials["Material.007"]}
				position={[-0.696, -0.046, 0.217]}
				rotation={[Math.PI / 2, 0, -Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface504002.geometry}
				material={materials["Material.007"]}
				position={[-0.747, -0.046, 0.181]}
				rotation={[Math.PI / 2, 0, Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface507001.geometry}
				material={materials["Material.007"]}
				position={[-0.987, -0.046, 0.217]}
				rotation={[Math.PI / 2, 0, -Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface506001.geometry}
				material={materials["Material.007"]}
				position={[-0.987, -0.046, 0.217]}
				rotation={[Math.PI / 2, 0, -Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.polySurface505001.geometry}
				material={materials["Material.007"]}
				position={[-0.987, -0.046, 0.217]}
				rotation={[Math.PI / 2, 0, -Math.PI / 2]}
				scale={0.011}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Plane012.geometry}
				material={materials["Material.007"]}
				position={[-2.626, 0.148, -1.093]}
			/>
			<mesh
				castShadow
				receiveShadow
				geometry={nodes.Plane013.geometry}
				material={materials["Material.007"]}
				position={[-2.377, 0.148, -0.438]}
			/>
		</group>
	);
}

useGLTF.preload("models/factory2.glb");
